module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-down-a7d9ebbc0af6ff75f42cc140c165c9cd.svg";